module.exports = __webpack_public_path__ + "static/media/videoBG.db195216.svg";